module.exports = __webpack_public_path__ + "img/1970East-074_WEB-min.4a653565.jpg";